import styled from 'styled-components';
import { Props } from '.';

export const FlexWrapper = styled.div<Props>`
  display: flex;
  justify-content: ${({ justifyContent = 'flex-start' }) => justifyContent};
`;
